/* IPERTECH 2026 — COLLECTION PAGE v1 */
(function(){
  'use strict';
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    document.querySelectorAll('[data-ipt-col]').forEach(initCol);
  });

  function initCol(root){
    initMobileDrawer(root);
    initSortAutoSubmit(root);
    initViewToggle(root);
    initPriceValidate(root);
    initSubmitOnChange(root);
  }

  /* ---- DRAWER MOBILE ---- */
  function initMobileDrawer(root){
    var btn = root.querySelector('[data-ipt-col-filt-open]');
    var closeBtn = root.querySelector('[data-ipt-col-filt-close]');
    var sidebar = root.querySelector('[data-ipt-col-side]');
    var overlay = root.querySelector('[data-ipt-col-filt-overlay]');
    if(!btn || !sidebar) return;

    function open(){
      sidebar.classList.add('is-open');
      if(overlay) overlay.classList.add('is-open');
      document.body.classList.add('ipt-col-filt-open');
    }
    function close(){
      sidebar.classList.remove('is-open');
      if(overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('ipt-col-filt-open');
    }
    btn.addEventListener('click', open);
    if(closeBtn) closeBtn.addEventListener('click', close);
    if(overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && sidebar.classList.contains('is-open')) close();
    });
  }

  /* ---- ORDINAMENTO: auto submit ---- */
  function initSortAutoSubmit(root){
    var sel = root.querySelector('[data-ipt-col-sort]');
    if(!sel) return;
    sel.addEventListener('change', function(){
      var form = sel.closest('form');
      if(form){ form.submit(); return; }
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---- TOGGLE VISTA grid/list ---- */
  function initViewToggle(root){
    var grid = root.querySelector('[data-ipt-col-grid]');
    var btns = root.querySelectorAll('[data-ipt-col-view]');
    if(!grid || !btns.length) return;

    var saved = null;
    try { saved = localStorage.getItem('ipt_col_view'); } catch(e){}
    if(saved === 'list'){ grid.classList.add('is-list'); }
    btns.forEach(function(b){
      var mode = b.getAttribute('data-ipt-col-view');
      if((saved === 'list' && mode === 'list') || (saved !== 'list' && mode === 'grid')){
        b.classList.add('is-active');
      }
    });

    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var mode = btn.getAttribute('data-ipt-col-view');
        btns.forEach(function(b){ b.classList.toggle('is-active', b === btn); });
        grid.classList.toggle('is-list', mode === 'list');
        try { localStorage.setItem('ipt_col_view', mode); } catch(e){}
      });
    });
  }

  /* ---- PREZZO: validazione min/max ---- */
  function initPriceValidate(root){
    var min = root.querySelector('[data-ipt-col-price-min]');
    var max = root.querySelector('[data-ipt-col-price-max]');
    if(!min || !max) return;
    function clamp(){
      var minV = parseFloat(min.value) || 0;
      var maxV = parseFloat(max.value) || 0;
      if(maxV > 0 && minV > maxV){
        min.value = maxV;
      }
    }
    min.addEventListener('change', clamp);
    max.addEventListener('change', clamp);
  }

  /* ---- AUTO-SUBMIT su change checkbox (desktop) ---- */
  function initSubmitOnChange(root){
    if(window.innerWidth < 992) return;
    var form = root.querySelector('[data-ipt-col-filters]');
    if(!form) return;
    var inputs = form.querySelectorAll('input[type=checkbox]');
    inputs.forEach(function(i){
      i.addEventListener('change', function(){
        clearPageParam(form);
        form.submit();
      });
    });
  }

  function clearPageParam(form){
    var pageInput = form.querySelector('input[name=page]');
    if(pageInput) pageInput.value = '';
  }
})();
